import { render, staticRenderFns } from "./checkoutSectionInstances.vue?vue&type=template&id=33945572"
import script from "./checkoutSectionInstances.vue?vue&type=script&lang=js"
export * from "./checkoutSectionInstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports